export type BulkStep = 'input' | 'preview' | 'done';

export const REASON_MAX = 39;
export const MAX_ENTRIES = 5000;

// AgreementProcessFlowType enum values; labels resolved via `flow-type-{value}` translations with these fallbacks
export const BULK_FLOW_TYPES = [
	{ fallback: 'Private Banking Onboarding', value: 1 },
	{ fallback: 'Investment Banking Onboarding', value: 2 },
	{ fallback: 'RiskQ Renewal', value: 3 },
	{ fallback: 'Asset Counseling', value: 4 },
	{ fallback: 'Derivatives Onboarding', value: 5 },
	{ fallback: 'Portfolio For Children', value: 6 }
] as const;
